const EXPANDABLE_AREA_TYPES = [
  'toggle-btn',
  'partial'
];

export { EXPANDABLE_AREA_TYPES };
